module.exports = __webpack_public_path__ + "4f2d5743dcd9a0512e2ea563cb72876f.jpg";